import React from 'react';
import {connect} from 'react-redux';
import {deleteItem} from '../redux.js';
import {changeQuantity} from '../redux.js';

const BasketProduct = (props) =>
	<div className='prod'>
		<img src={require(`../../img/${props.product.img}`)}/>
		<div className='name'>{props.product.name}</div>
		<div>цiна : {props.product.price}$</div>
		<div className='price'>
			<img 
				onClick={() =>props.changeQuantity(props.product.name,-1)}
				className='arrow left' src={require('../../img/arrow.png')}/>
			<div>кiлькiсть : {props.product.quantity}шт</div>
			<img 
				onClick={() =>props.changeQuantity(props.product.name,1)}
				className='arrow right' src={require('../../img/arrow.png')}/>
		</div>
		<div>сумма : {props.product.price*props.product.quantity}$</div>
		<div onClick={() =>props.deleteItem(props.product.name)} className='reset'>
			<img src={require('../../img/basket/cross.png')}/>
		</div>
	</div>

export default connect(
	state =>({
		store: state
	}),
	dispatch =>({
		deleteItem:(item) =>{
			dispatch(deleteItem(item))
		},
		changeQuantity:(item,n) =>{
			dispatch(changeQuantity(item,n))
		}
	})
)(BasketProduct);